import React from 'react';
import { Spin } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

import { SUPPORT_PHONE } from '../../../certificate-payment-success/certificate-payment-success';

import type { PublicPaymentStateCardProps } from './types';
import styles from './styles.module.scss';

export function PublicPaymentStateCard({
  variant,
  titleMessageId,
  descriptionMessageId,
  icon,
}: PublicPaymentStateCardProps): React.ReactElement {
  const isLoading = variant === 'loading';

  return (
    <div className={styles.wrapper}>
      <div className={styles.contentFlex}>
        <div
          className={styles.statusCard}
          role={isLoading ? 'status' : 'alert'}
          aria-busy={isLoading}
          aria-live={isLoading ? 'polite' : 'assertive'}
        >
          <div className={styles.statusHeader}>
            <span
              className={`${styles.iconWrap}${isLoading ? '' : ` ${styles.iconWrapError}`}`}
              aria-hidden
            >
              {isLoading ? (
                <Spin size="large" />
              ) : (
                icon && <FontAwesomeIcon icon={icon} className={styles.icon} />
              )}
            </span>
            <div className={styles.statusHeaderText}>
              <h1 className={styles.statusTitle}>
                <FormattedMessage id={titleMessageId} />
              </h1>
              <p className={styles.statusDescription}>
                <FormattedMessage id={descriptionMessageId} />
              </p>
            </div>
          </div>

          {!isLoading && (
            <dl className={styles.supportDetails}>
              <div className={styles.supportRow}>
                <dt>
                  <FormattedMessage id="certificates.success.support" />
                </dt>
                <dd>
                  <a href={`tel:${SUPPORT_PHONE.replace(/\s/g, '')}`} className={styles.supportLink}>
                    {SUPPORT_PHONE}
                  </a>
                </dd>
              </div>
            </dl>
          )}
        </div>
      </div>
    </div>
  );
}
